import { addMessages, init, getLocaleFromNavigator, locale, getLocaleFromPathname } from 'svelte-i18n';
export const lngs = process.env.LANGUAGES ? process.env.LANGUAGES.split(',') : ['pt'];
const localesDictionary = {
    pt: {
        search: {
            placeholder: 'Pesquisar',
            'empty-selection': 'Sem resultados.'
        }
    },
    en: {
        search: {
            placeholder: 'Search',
            'empty-selection': 'No results.'
        }
    },
    fr: {
        search: {
            placeholder: 'Chercher',
            'empty-selection': 'Aucun résultat.'
        }
    },
    es: {
        search: {
            placeholder: 'Buscar',
            'empty-selection': 'No hay resultados.'
        }
    }
};
const LOCALE = process.env.LOCALE;
export const isLocale = (locale) => lngs.includes(locale);
export const fallbackLocale = LOCALE && isLocale(LOCALE) ? LOCALE : 'pt';
lngs.forEach(l => {
    if (l in localesDictionary) {
        addMessages(l, localesDictionary[l]);
    }
});
locale.subscribe(lng => {
    if (lng)
        localStorage.setItem('svelte-i18n-locale', lng);
});
let initialLocale;
const detectedLocale = getLocaleFromPathname(/^\/(pt|en|fr|es)\//) ||
    localStorage.getItem('svelte-i18n-locale') ||
    getLocaleFromNavigator() ||
    fallbackLocale;
if (lngs.includes(detectedLocale))
    initialLocale = detectedLocale;
else if (detectedLocale.indexOf('-') > 0) {
    const foundLng = lngs.find(l => detectedLocale.indexOf(l + '-') === 0);
    if (foundLng)
        initialLocale = foundLng;
}
void init({
    fallbackLocale,
    initialLocale
});
